import { required } from "ra-core";
import { DateInput } from "@/components/admin/date-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { AttachmentLinksInput } from "../misc/AttachmentLinksInput";
import { MarkdownInput } from "../misc/MarkdownInput";

export const PROJECT_STATUSES = [
  { id: "active", name: "Active" },
  { id: "on_hold", name: "On hold" },
  { id: "delivered", name: "Delivered" },
  { id: "cancelled", name: "Cancelled" },
];

export const PROJECT_STAGES = [
  { id: "discovery", name: "Discovery" },
  { id: "design", name: "Design" },
  { id: "build", name: "Build" },
  { id: "review", name: "Review" },
  { id: "launch", name: "Launch" },
];

/**
 * Two columns from `sm` up. Short fields pair off; the name and description
 * span both, because a half-width text box for a project description invites
 * one-line descriptions.
 */
export function ProjectInputs() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 w-full [&>*]:min-w-0">
      <div className="sm:col-span-2">
        <TextInput source="name" validate={required()} helperText={false} />
      </div>
      <div className="sm:col-span-2">
        <MarkdownInput source="description" rows={3} helperText={false} />
      </div>

      <SelectInput
        source="status"
        choices={PROJECT_STATUSES}
        defaultValue="active"
        validate={required()}
        helperText={false}
      />
      <SelectInput
        source="stage"
        choices={PROJECT_STAGES}
        defaultValue="discovery"
        validate={required()}
        helperText={false}
      />

      <DateInput source="start_date" helperText={false} />
      <DateInput source="due_date" helperText={false} />

      {/* The client is a contact, so this is invisible to anyone without
          contacts.list -- a developer editing a project does not see it, and
          RLS refuses the row even if they ask for it directly. */}
      <ReferenceInput source="client_contact_id" reference="contacts">
        <SelectInput
          optionText={(record) =>
            record ? `${record.first_name} ${record.last_name}` : ""
          }
          helperText={false}
        />
      </ReferenceInput>

      <ReferenceInput source="company_id" reference="companies">
        <SelectInput optionText="name" helperText={false} />
      </ReferenceInput>

      <div className="sm:col-span-2">
        <AttachmentLinksInput />
      </div>
    </div>
  );
}
